import { Shield } from "lucide-react";
import { cn } from "@/lib/utils";

export function StaffBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 rounded-full bg-indigo-500/15 px-1.5 py-0.5 text-[10px] font-semibold text-indigo-600 dark:text-indigo-400 whitespace-nowrap",
        className,
      )}
    >
      <Shield className="h-2.5 w-2.5 fill-current" />
      Staff
    </span>
  );
}
